import { render, staticRenderFns } from "./SelectAddressesDlg.vue?vue&type=template&id=2e62c2b5"
import script from "./SelectAddressesDlg.vue?vue&type=script&lang=js"
export * from "./SelectAddressesDlg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports